import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetKeywordsFromStockCodes(stockCodes, limit) {
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/keywords/by_stock_codes',
    method: 'GET',
    params: {
      stock_codes: stockCodes,
      top: limit,
      search_query_id: window.Livewire?.request?.searchQuery?.id,
    },
  }, { manual: true });
}
